var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.059,
    height: 18.059,
    viewBox: "0 0 18.059 18.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone-square-alt",
    "data-name": "Icon awesome-phone-square-alt",
    d: "M16.124,2.25H1.935A1.935,1.935,0,0,0,0,4.185V18.374a1.935,1.935,0,0,0,1.935,1.935H16.124a1.935,1.935,0,0,0,1.935-1.935V4.185A1.935,1.935,0,0,0,16.124,2.25Zm-.661,12.39-.6,2.62a.6.6,0,0,1-.589.469A11.691,11.691,0,0,1,2.58,6.039a.633.633,0,0,1,.469-.589l2.62-.6A.735.735,0,0,1,5.8,4.83.656.656,0,0,1,6.36,5.2L7.57,8.018a.722.722,0,0,1,.049.238.685.685,0,0,1-.222.468L5.869,9.974a9.348,9.348,0,0,0,4.465,4.465l1.25-1.527a.685.685,0,0,1,.468-.222.72.72,0,0,1,.238.049l2.822,1.209a.655.655,0,0,1,.366.556A.7.7,0,0,1,15.463,14.64Z",
    transform: "translate(0 -2.25)",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSquare);
export default __webpack_public_path__ + "static/media/phone-square.f1b2e9b154a424d538a17c68ffe3f49b.svg";
export { ForwardRef as ReactComponent };